import React from 'react';
import {
  FontWeight, Message, Stack, Text,
} from '@doveit/bricks';
import { WizardContact } from '../../../providers/api/dtos';
import { groupValidationErrorsByContact } from '../../utils/groupValidationErrorsByContact';

interface GroupedValidationErrorsProps {
  message: string,
  errorInfo: Record<string, string>,
  contacts?: WizardContact[],
  pathPrefix?: string,
}

const GroupedValidationErrors: React.FC<GroupedValidationErrorsProps> = ({
  message,
  errorInfo,
  contacts,
  pathPrefix,
}) => {
  const { contactErrors, otherErrors } = React.useMemo(
    () => groupValidationErrorsByContact(errorInfo, contacts, pathPrefix),
    [errorInfo, contacts, pathPrefix],
  );

  const hasContactErrors = contactErrors.length > 0;
  const hasOtherErrors = otherErrors.length > 0;

  return (
    <Message type="critical" message={message}>
      <Stack gap={150}>
        {hasOtherErrors && (
          <ul>
            {otherErrors.map((errorMessage) => (
              <li key={errorMessage}>{errorMessage}</li>
            ))}
          </ul>
        )}

        {hasContactErrors && contactErrors.map(({ contactIndex, contactName, errors }) => (
          <div key={contactIndex}>
            <Text.BodySmall fontWeight={FontWeight.MEDIUM}>
              {contactName}
            </Text.BodySmall>
            <ul>
              {errors.map((errorMessage) => (
                <li key={errorMessage}>{errorMessage}</li>
              ))}
            </ul>
          </div>
        ))}
      </Stack>
    </Message>
  );
};

export default GroupedValidationErrors;
